import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import {
  AgrLogoWideModule,
  AgrPageDetailModule,
  AgrPageToolbarModule,
  AgrPrintPageModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { AgrTableModule } from '@next/core-lib/table';

import { SharedModule } from './../shared/shared.module';
import { GeneralInfoComponent } from './components/general-info/general-info.component';
import { CropFieldOverviewComponent } from './cropfield-overview/cropfield-overview.component';
import { SoilAnalysisReportComponent } from './soil-analysis-report/soil-analysis-report.component';

@NgModule({
  declarations: [GeneralInfoComponent, CropFieldOverviewComponent, SoilAnalysisReportComponent],
  imports: [
    RouterModule,
    SharedModule,
    MatIconModule,
    MatExpansionModule,
    MatTableModule,
    AgrTableModule,
    MatDividerModule,
    AgrPageToolbarModule,
    AgrValueRowModule,
    AgrLogoWideModule,
    AgrPageDetailModule,
    AgrPrintPageModule,
    MatListModule,
    CommonModule,
    AgrI18nSharedModule,
  ],
})
export class ReportsModule {}
